"use client";
import BreadCrumbs from "@/components/BreadCrumbs/BreadCrumbs";
import "./Terms.scss";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTermsOfUses, selectAllTermsOfUses } from "@/slice/tAndcSlice";
export default function TermsCondition() {
  const dispatch = useDispatch();
  const data = useSelector(selectAllTermsOfUses);

  useEffect(() => {
    dispatch(fetchTermsOfUses());
  }, []);
  const termsAndCondition = data?.data?.map((i) => ({
    title: i?.title,
    description: i?.description,
  }));

  return (
    <>
      <BreadCrumbs />
      <div className="termsWrapper">
        <div className="termsContainer">
          <p className="heading">
            <span className="highlightHeading">Terms of Use</span>
          </p>
          <div className="termsInfo">
            <p className="termsInfoParagraph">
              Thank you for using the FitSib mobile application and
              www.FitSib.com (hereafter referred as “Website”), the online
              platforms of Fitsib Inc.,USA By accessing and using any part of
              these Services, you shall be deemed to have legally bound by the
              Terms of Use contained herein. If you do not agree to these Terms
              of Use, please do not use this application or Website.
            </p>
          </div>
          {termsAndCondition &&
            termsAndCondition?.map((i) => (
              <div key={i.title} className="infoService">
                <p className="subheading">
                  <span className="subHighlightHeading">{i.title}</span>
                </p>
                <div className="infoDetails">
                  <p className="infoInfoParagraph">{i?.description}</p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
}
